(() => {
  if (window.FourPawV6SecondaryVideo) {
    window.FourPawV6SecondaryVideo.scan();
    return;
  }

  const cleanups = new WeakMap();
  const init = (section) => {
    if (!(section instanceof HTMLElement) || cleanups.has(section)) return;
    const video = section.querySelector('[data-fp-secondary-video]');
    const source = video?.querySelector('source[data-src]');
    if (!video || !source) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const carouselRoot = section.classList.contains('fp-video-band--mobile-carousel')
      && window.matchMedia('(max-width: 767px)').matches
      ? section.querySelector('.fp-video-band__videos')
      : null;
    let loaded = Boolean(source.getAttribute('src'));
    let inViewport = false;
    let loadObserver = null;
    let playbackObserver = null;
    const syncMotionPreference = () => {
      if (reducedMotion.matches || !inViewport) {
        video.pause();
        return;
      }
      if (loaded && video.dataset.autoplay === 'true') video.play().catch(() => {});
    };
    const loadVideo = () => {
      if (loaded) return;
      loaded = true;
      if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
      source.src = source.dataset.src;
      video.load();
      video.addEventListener('canplay', syncMotionPreference, { once: true });
    };
    if ('IntersectionObserver' in window) {
      loadObserver = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        loadObserver.disconnect();
        loadVideo();
      }, { rootMargin: '200px 0px' });
      loadObserver.observe(video);
      playbackObserver = new IntersectionObserver(([entry]) => {
        inViewport = entry.isIntersecting;
        syncMotionPreference();
      }, { root: carouselRoot, threshold: carouselRoot ? 0.65 : 0.15 });
      playbackObserver.observe(video);
    } else {
      inViewport = true;
      loadVideo();
    }
    reducedMotion.addEventListener?.('change', syncMotionPreference);
    cleanups.set(section, () => {
      loadObserver?.disconnect();
      playbackObserver?.disconnect();
      reducedMotion.removeEventListener?.('change', syncMotionPreference);
      video.pause();
      cleanups.delete(section);
    });
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-fp-video-band]')) init(scope);
    scope.querySelectorAll?.('[data-fp-video-band]').forEach(init);
  };
  const unload = (scope) => {
    if (scope.matches?.('[data-fp-video-band]')) cleanups.get(scope)?.();
    scope.querySelectorAll?.('[data-fp-video-band]').forEach((section) => cleanups.get(section)?.());
  };

  window.FourPawV6SecondaryVideo = Object.freeze({ scan });
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
  document.addEventListener('shopify:block:select', (event) => scan(event.target.closest?.('[data-fp-video-band]') || event.target));
})();
